import {Injectable} from '@angular/core';
import {Resolve, ActivatedRouteSnapshot, Router} from '@angular/router';
import {Observable, of} from 'rxjs';
import {UiBlockerService} from '../services/ui-blocker.service';
import {catchError, map} from 'rxjs/operators';
import {UtilService} from '../services/util.service';
import {SimulationRunResult} from '../models/simulation-run-result.model';
import {SimulationRunResultService} from '../services/simulation-run-result.service';

@Injectable({providedIn: 'root'})
export class SimulationRunResultResolver implements Resolve<SimulationRunResult> {

  constructor(private simulationRunResultService: SimulationRunResultService,
              private uiBlockerService: UiBlockerService,
              private utilService: UtilService,
              private router: Router) {
  }

  resolve(route: ActivatedRouteSnapshot): Observable<SimulationRunResult> {
    this.uiBlockerService.block();
    const projectId = +this.utilService.getRouteParameter(route, 'projectId');
    const modelRunId = this.utilService.getRouteParameter(route, 'modelRunId');
    const scenarioId = this.utilService.getRouteParameter(route, 'scenarioId');
    return this.simulationRunResultService.fetchAll(projectId, modelRunId, scenarioId).pipe(map((results) => {
      this.uiBlockerService.unblock();
      return results;
    }), catchError(() => {
      this.uiBlockerService.unblock();
      this.router.navigate(['/404']);
      return of(null);
    }));
  }
}
